import React from 'react';
import { CloseIcon } from '../icons/icons';
import { IconButton } from '../actions';

import styles from './modal-header.css';
import Colors from '../colors';

interface ModalHeaderProps {
  /** Callback for when the close icon is clicked */
  onClose: () => void;
  /** Header elements for the modal */
  children?: React.ReactNode;
}

/**
 * Modal Header component
 *
 * @param {ModalHeaderProps} param
 *
 * @returns JSX.ELEMENT
 */
export const ModalHeader = ({ onClose, children }: ModalHeaderProps) => (
  <header className={styles.header}>
    <span data-testid="modal-header" className={styles.title}>
      {children}
    </span>
    <IconButton size={'14px'} color={Colors.MineShaft} onClick={onClose} data-testid="close-button">
      <CloseIcon />
    </IconButton>
  </header>
);

export default ModalHeader;
